import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type ForgotPasswordState = {
  loading: boolean;
  error: boolean;
  errorMessage: string | null;
  success: boolean;
  data: unknown | null;
};

const initialState: ForgotPasswordState = {
  loading: false,
  error: false,
  errorMessage: null,
  success: false,
  data: null,
};

interface ForgotPasswordPayload {
  email: string;
}

export const forgotPassword = createAsyncThunk<
  unknown,
  ForgotPasswordPayload,
  { rejectValue: string }
>('forgotPassword', async (payload, thunkAPI) => {
  try {
    const { data } = await api.post('/api/account/forgot-password', {
      email: payload.email,
    });
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      'Failed to send reset link';
    return thunkAPI.rejectWithValue(message);
  }
});

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    resetForgotPassword: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
    });
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload ?? 'Failed to send reset link';
    });
  },
});

export const { resetForgotPassword } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
